// 這是Webpack掛載起始點
import Index from '../.components/provider/index.vue'
import Edit from '../.components/provider/edit.vue'
import New from '../.components/provider/new.vue'

const main_router = 'provider_distributions'
const new_router = 'new_provider_distribution'
const edit_router = 'edit_provider_distribution'

const router = [
    {
        path: '',
        component: Index,
        name: 'provider_distributions',
        meta: {
            api_name: 'api_v1_provider_materials',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'edit/:identity',
        component: Edit,
        name: 'edit_provider_distribution',
        meta: {
            api_name: 'api_v1_provider_distribution_update',
            breadcrumb: [main_router, edit_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_provider_distribution',
        meta: {
            api_name: 'api_v1_provider_distributions_create',
            breadcrumb: [main_router, new_router]
        }
    },
]

export default router
